import React from 'react';

const LandingHowItWorks = ({ t }) => {
  return (
    <section className="px-4 py-16" style={{ backgroundColor: '#E8F5E9' }}>
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <h2 
            className="text-2xl md:text-3xl lg:text-4xl text-center mb-12"
            style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
            data-testid="how-it-works-title"
          >
            {t('landing.howItWorks.title')} <span style={{ color: '#27AE60' }}>{t('landing.howItWorks.titleHighlight')}</span>
          </h2>
          
          {/* 4 Phones Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {/* Phone 1 - Income & Expenses */}
            <div className="flex flex-col items-center">
              <div 
                className="relative bg-gray-800 rounded-[2rem] p-2 shadow-xl w-full max-w-[180px]"
              >
                {/* Phone Notch */}
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-4 bg-gray-800 rounded-b-xl z-10"></div>
                
                {/* Screen */}
                <div 
                  className="rounded-[1.5rem] bg-white p-4 flex flex-col items-center justify-center text-center"
                  style={{ minHeight: '280px' }}
                >
                  <h3 
                    className="text-lg mb-3"
                    style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
                  >
                    {t('landing.phones.phone1.title')}
                  </h3>
                  <p 
                    className="text-sm"
                    style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
                  >
                    {t('landing.phones.phone1.text')}
                  </p>
                </div>
                
                {/* Home Indicator */}
                <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gray-600 rounded-full"></div>
              </div>
            </div>

            {/* Phone 2 - Goals & Obligations */}
            <div className="flex flex-col items-center">
              <div 
                className="relative bg-gray-800 rounded-[2rem] p-2 shadow-xl w-full max-w-[180px]"
              >
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-4 bg-gray-800 rounded-b-xl z-10"></div>
                
                <div 
                  className="rounded-[1.5rem] bg-white p-4 flex flex-col items-center justify-center text-center"
                  style={{ minHeight: '280px' }}
                >
                  <h3 
                    className="text-lg mb-3"
                    style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
                  >
                    {t('landing.phones.phone2.title')}
                  </h3>
                  <p 
                    className="text-sm"
                    style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
                  >
                    {t('landing.phones.phone2.text')}
                  </p>
                </div>
                
                <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gray-600 rounded-full"></div>
              </div>
            </div>

            {/* Phone 3 - Always Accurate */}
            <div className="flex flex-col items-center">
              <div 
                className="relative bg-gray-800 rounded-[2rem] p-2 shadow-xl w-full max-w-[180px]"
              >
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-4 bg-gray-800 rounded-b-xl z-10"></div>
                
                <div 
                  className="rounded-[1.5rem] bg-white p-4 flex flex-col items-center justify-center text-center"
                  style={{ minHeight: '280px' }}
                >
                  <h3 
                    className="text-lg mb-3"
                    style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
                  >
                    {t('landing.phones.phone3.title')}
                  </h3>
                  <p 
                    className="text-sm"
                    style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
                  >
                    {t('landing.phones.phone3.text')}
                  </p>
                </div>
                
                <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gray-600 rounded-full"></div>
              </div>
            </div>

            {/* Phone 4 - Magic Number (Highlighted) */}
            <div className="flex flex-col items-center">
              <div 
                className="relative bg-gray-900 rounded-[2.2rem] p-2 shadow-2xl w-full max-w-[200px] transform scale-105"
                style={{ border: '3px solid #27AE60' }}
              >
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-4 bg-gray-900 rounded-b-xl z-10"></div>
                
                <div 
                  className="rounded-[1.7rem] bg-white p-5 flex flex-col items-center justify-center text-center"
                  style={{ minHeight: '300px' }}
                >
                  <h3 
                    className="mb-3"
                    style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60', fontSize: '1.4rem' }}
                  >
                    {t('landing.phones.phone4.title')}
                  </h3>
                  <p 
                    className="text-sm"
                    style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
                  >
                    {t('landing.phones.phone4.text')}
                  </p>
                </div>
                
                <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gray-500 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default LandingHowItWorks;
